<template>
    <div>
        <b-card class="text-center" title="Asignacion De Permisos">
        </b-card>
        <b-card class="text-left"><b-row>
            <b-col md="3">
                 <label for="nombre">Buscar</label>
                 <b-form-input v-model="id"  type="text"  placeholder="Doc. Identificacion" text="Buscar" @change="consultar"></b-form-input>
            </b-col>
            <b-col md="9">
                 <label for="Numbreu">Nombre usuario</label>
                 <b-form-input v-model="nombreCom"  type="text"  placeholder="Nombre Usuario" disabled></b-form-input>
            </b-col>
            <b-col md="3">
                <br>
                <label for="Fecha">Fecha</label> 
                <b-input-group>
                <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="date" required v-model="fecha"></b-form-input>
                </b-input-group>
            </b-col>
            <b-col md="3">
                <br>
                <label for="Hora">Hora</label>        
                <b-input-group>
                <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-clock-o"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="time" required v-model="hora"></b-form-input>
                </b-input-group>
            </b-col>
            <b-col md="6">
                <br>
                <label for="Tipo">Tipos</label> 
                <b-form-group label-for="Tipo">
                <b-form-select :options="opciones" v-model="tipo"></b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="12">
                <label for="Observaciones">Observaciones</label>  
                <b-form-textarea id="textarea1" placeholder="" :rows="3" :max-rows="6" v-model="obj">
                </b-form-textarea>
            </b-col>
            <b-col md="3">
                <br>
                <b-button variant="success" @click="enviar" >Crear</b-button>
            </b-col>
        </b-row>
        </b-card>
    </div>
</template>

<script>
export default {
 name: 'permislist', 
 data (){
        return{
        id:'',
        nombreCom:'',
        fecha:'',
        hora:'',
        tipo:'',
        obj:'',
        idUser:'',
        opciones:[{
            'value': 1,
            'text': 'Entrada'
        },{
            'value': 2,
            'text': 'Salida '
        }]
        }
 },
    methods:{
        consultar(){
            let  array={'id':this.id}
            this.$store.dispatch('controlaccesopermisslist', array).then(Response=>{
                if( this.$store.getters.controlaccesopermiss != null ){
                    this.nombreCom= this.$store.getters.controlaccesopermiss.name
                    this.idUser= this.$store.getters.controlaccesopermiss.id
                    
                }else{
                    alert("No Existe Usuario");
                }
                
            })  
         
        },
        enviar(){
            if(this.idUser !='' && this.fecha !='' && this.hora !='' && this.tipo !='' && this.obj !=''){
                    let  array={'idUser':this.idUser,'fecha':this.fecha,'hora':this.hora,'tipo':this.tipo,'observaciones':this.obj}
                    this.$store.dispatch('controlaccesopermisslistenviar', array).then(Response=>{
                    this.$root.showInfoDialog('alerta', this.$store.getters.controlaccesopermiss.mensaje, 'Aceptar')
                    this.creardata()
                    
                }) 
            }else{
                alert('Tienes Campos Vacios');
            }
             

    },
    creardata(){
        this.id=''
        this.nombreCom=''
        this.fecha=''
        this.hora=''
        this.tipo=''
        this.obj=''
        this.idUser=''
    }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/controlacceso/permiss.vue